import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function JournalArticleCard({ article, index = 0 }) {
  return (
    <motion.article
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.1 }}
      className="card-flat overflow-hidden group"
      data-testid={`journal-card-${article.slug}`}
    >
      <div className="aspect-[16/9] overflow-hidden">
        <img
          src={article.image_url}
          alt={article.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="p-6 space-y-4">
        <span className="overline text-tiger-orange">
          {article.category}
        </span>
        <h3 className="font-playfair text-2xl font-semibold text-dark-cedar leading-tight">
          {article.title}
        </h3>
        <p className="text-dark-cedar/70 leading-relaxed">
          {article.excerpt}
        </p>
        <Link
          to={`/journal/${article.slug}`}
          className="inline-flex items-center space-x-2 text-tiger-orange font-inter font-medium text-sm transition-transform hover:translate-x-1"
        >
          <span>Read more</span>
          <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </motion.article>
  );
}